/* eslint-disable new-cap */
/* eslint-disable camelcase */
import Vue from 'vue';
import { loadScript } from 'src/util/helper';

const $stripe = loadScript('https://js.stripe.com/v3/')
	.then(() => window.Stripe(process.env.VUE_APP_STRIPE_KEY))
	.catch(console.error);

Vue.prototype.$stripe = {
	async createSource(name, iban) {
		const stripe = await $stripe;
		return stripe.createSource({
			type: 'sepa_debit',
			currency: 'eur',
			sepa_debit: {
				iban,
			},
			owner: {
				name,
			},
		});
	},
};
